import { useRef } from "react";
import { Link } from "react-router-dom";
import { motion, useReducedMotion, useScroll, useTransform } from "framer-motion";
import { EASE, MaskedLines } from "@/components/aklive/motion";
import { PlaceholderBlock } from "@/components/aklive/PlaceholderBlock";

export const HomeHero = () => {
  const reduce = useReducedMotion();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const yA = useTransform(scrollYProgress, [0, 1], [0, 28]);

  return (
    <section ref={ref} className="relative pt-28 md:pt-40" data-testid="home-hero-section">
      <div className="container-ak">
        <h1 className="font-display text-[8.5vw] font-bold leading-[1.02] tracking-[-0.03em] text-ink sm:text-5xl md:text-6xl lg:text-7xl xl:text-[5.5rem]">
          <MaskedLines
            delay={0.25}
            lines={[
              "Design built around",
              "what your business",
              <span key="l3">
                needs to achieve<span className="text-ember">.</span>
              </span>,
            ]}
          />
        </h1>

        <motion.p
          initial={reduce ? { opacity: 0 } : { opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.65, ease: EASE }}
          className="mt-8 max-w-[600px] text-base leading-relaxed text-ink2 md:mt-10 md:text-lg"
        >
          AKLIVE combines business thinking with design to build brands, websites, presentations,
          packaging and communication systems for companies moving forward.
        </motion.p>

        <motion.div
          initial={reduce ? { opacity: 0 } : { opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.8, ease: EASE }}
          className="mt-10 flex flex-col gap-4 sm:flex-row md:mt-12"
        >
          <Link to="/contact" data-testid="home-hero-start-btn" className="btn-primary h-14 px-8 text-base">
            Start a Project
          </Link>
          <Link to="/work" data-testid="home-hero-work-btn" className="btn-secondary h-14 px-8 text-base">
            View Our Work
          </Link>
        </motion.div>
      </div>

      <div className="container-ak mt-16 md:mt-24">
        <motion.div
          initial={reduce ? { opacity: 0 } : { clipPath: "inset(100% 0% 0% 0%)" }}
          animate={reduce ? { opacity: 1 } : { clipPath: "inset(0% 0% 0% 0%)" }}
          transition={{ duration: 0.9, delay: 0.7, ease: EASE }}
        >
          <motion.div style={reduce ? undefined : { y: yA }} className="grid grid-cols-12 items-stretch gap-4 md:gap-8">
            <div className="col-span-12 md:col-span-8">
              <PlaceholderBlock label="[WEBSITE MOCKUP — 16:10]" ratio="16 / 10" />
            </div>
            <div className="hidden md:col-span-4 md:block">
              <PlaceholderBlock label="[BRAND SYSTEM — PORTRAIT]" fill />
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};
